import React, { forwardRef } from 'react';

interface IWidgetWrapperProps {
  children: React.ReactNode;
  testId: string;
  className?: string;
}

export const WidgetWrapper = forwardRef<HTMLDivElement, IWidgetWrapperProps>(({ children, testId, className }, ref) => (
  <div
    ref={ref}
    className={`shadow-widgetCard border-bw03 border-[0.5px] rounded-[12px] bg-bw00 ${className}`}
    data-testid={testId}
  >
    {children}
  </div>
));

WidgetWrapper.displayName = 'WidgetWrapper';
